<div class="container">
  <div class="text-center">
    <h1 class="fs-3 fw-bold" style="color: #8e0e00">Monthly Revenue Report</h1>
  </div>

  <!-- Filter Section -->
  <div class="row mb-3 mt-3 d-flex align-items-end">
    <!-- City Dropdown -->
    <div class="col-md-2">
      <label for="city" class="form-label">City</label>
      <select
        class="form-select"
        id="city"
        [(ngModel)]="selectedCityId"
        (change)="handleCityChange()"
      >
        <option value="">Select City</option>
        <option *ngFor="let city of cities" [value]="city?.id">
          {{ city?.cityName }}
        </option>
      </select>
    </div>

    <!-- Zone Dropdown -->
    <div class="col-md-2">
      <label for="zone" class="form-label">Zone</label>
      <select
        class="form-select"
        id="zone"
        [(ngModel)]="selectedZoneId"
        (change)="handleZoneChange()"
      >
        <option value="">Select Zone</option>
        <option *ngFor="let zone of zones" [value]="zone?.zoneId">
          {{ zone?.zoneName }}
        </option>
      </select>
    </div>

    <!-- Year Dropdown -->
    <div class="col-md-2">
      <label for="year" class="form-label">Year</label>
      <select
        class="form-select"
        id="year"
        [(ngModel)]="selectedYear"
        (change)="handleYearChange()"
      >
        <option value="">Select Year</option>
        <option *ngFor="let year of years" [value]="year">{{ year }}</option>
      </select>
    </div>
  </div>

  <!-- Buttons Section -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <button class="btn btn-success me-2" (click)="exportToExcel()">
        Export
      </button>
      <!-- <button class="btn btn-primary me-2">Print</button> -->
      <button class="btn btn-primary me-2" (click)="exportToPDF()">
        Print
      </button>
      <button class="btn btn-warning" (click)="clearFilter()">Clear</button>
    </div>
    <input
      type="text"
      class="form-control w-25"
      placeholder="Search..."
      [(ngModel)]="searchQuery"
      (input)="searchData()"
    />
  </div>

  <!-- Grid Table -->
  <div class="card shadow-lg p-3">
    <div class="d-flex align-items-center gap-3 ms-auto">
      <!-- From Date -->
      <div class="d-flex align-items-center gap-2">
        <label for="fromDate" class="form-label text-nowrap">From Date:</label>
        <input
          type="date"
          id="fromDate"
          [(ngModel)]="ngFromDate"
          (change)="onFromDateChange($event)"
          class="form-control"
        />
      </div>

      <!-- To Date -->
      <div class="d-flex align-items-center gap-2">
        <label for="toDate" class="form-label text-nowrap">To Date:</label>
        <input
          type="date"
          id="toDate"
          [(ngModel)]="ngToDate"
          (change)="onToDateChange($event)"
          [disabled]="!isToDateShow"
          class="form-control"
        />
      </div>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-bordered">
        <thead class="table-light">
          <tr>
            <th>Month</th>
            <th>Total Orders</th>
            <th>SAR Received From Requestor</th>
            <th>SAR Allocated to Dumpster</th>
            <th>SAR Allocated to Dumpyard</th>
            <th>SAR Allocated to Smart Sort</th>
            <th>SAR Refunded to Requestor</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of paginatedData">
            <td>{{ record.month }}</td>
            <td>{{ record.monthlyorderCount }}</td>
            <td>{{ record.sarReceivedFromReq }}</td>
            <td>{{ record.sarAllocatedToDumpster }}</td>
            <td>{{ record.sarAllocatedToDumpyard }}</td>
            <td>{{ record.sarAllocatedToSmartsort }}</td>
            <td>{{ record.sarRefundToReq }}</td>
          </tr>
          <tr *ngIf="filteredData.length === 0">
            <td colspan="10" class="text-center">No Data Found</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-light">
            <td class="text-end"><strong>Total</strong></td>
            <td>
              <strong>{{ totalOrders }}</strong>
            </td>
            <td>
              <strong>{{ sarReceivedFromRequestor }}</strong>
            </td>
            <td>
              <strong>{{ sarAllocatedToDumpster }}</strong>
            </td>
            <td>
              <strong>{{ sarAllocatedToDumpyard }}</strong>
            </td>
            <td>
              <strong>{{ sarAllocatedToSmartSort }}</strong>
            </td>
            <td>
              <strong>{{ sarRefundedToRequestor }}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center">
      <div *ngIf="paginatedData?.length > 0" class="text-muted mb-3">
        <strong>
          Showing
          {{ (currentPage - 1) * itemsPerPage + 1 }}
          to
          {{
            currentPage * itemsPerPage > paginatedData?.length
              ? paginatedData?.length
              : currentPage * itemsPerPage
          }}
          of {{ paginatedData?.length }} entries
        </strong>
      </div>
      <!-- <ngb-pagination [(page)]="currentPage" [pageSize]="itemsPerPage" [collectionSize]="filteredData.length"
        (pageChange)="onPageChange($event)">
      </ngb-pagination> -->
    </div>
  </div>
</div>
